import { useState } from "react";
import { navItems } from "@/mocks/dashan";

const FORM_URL = "https://readdy.ai/api/form/dagjdpjep053ijub2bd0";

export default function Footer() {
  const [status, setStatus] = useState<"idle" | "ok" | "err">("idle");
  const [msg, setMsg] = useState("");

  const scrollTo = (id: string) => {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    // 蜜罐检测：若被自动填充则伪装成功，不真正提交
    if ((fd.get("website_alt") as string)?.trim()) {
      setStatus("ok");
      setMsg("已提交成功，感谢关注！");
      return;
    }
    fd.delete("website_alt");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        body: fd,
        headers: { Accept: "application/json" },
      });
      const text = await res.text();
      let parsed: Record<string, any> = {};
      try {
        parsed = text ? JSON.parse(text) : {};
      } catch {
        /* ignore */
      }
      const serverMsg =
        parsed?.meta?.message ||
        parsed?.message ||
        parsed?.meta?.detail ||
        (text || "");
      const lower = String(serverMsg).toLowerCase();
      if (res.ok && parsed?.code === "OK" && !lower.includes("spam")) {
        form.reset();
        setStatus("ok");
        setMsg("订阅成功，新的一轮瓜和话术会第一时间发给你。");
      } else {
        setStatus("err");
        setMsg(
          lower.includes("spam")
            ? "提交太频繁，请稍后再试。"
            : (serverMsg && String(serverMsg)) ||
                "提交失败，请检查邮箱后重试。"
        );
      }
    } catch {
      setStatus("err");
      setMsg("网络开小差了，请稍后再试。");
    }
  };

  return (
    <footer className="bg-primary-700 text-background-50">
      <div className="px-4 md:px-6 max-w-[1200px] mx-auto pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
          {/* 品牌 + 订阅 */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-full bg-background-50 text-primary-600 flex items-center justify-center">
                <i className="ri-chat-smile-3-line text-xl"></i>
              </span>
              <span className="font-heading text-2xl font-bold text-background-50">
                搭讪<span className="text-accent-200">吃瓜</span>
              </span>
            </div>
            <p className="mt-4 text-background-100/90 leading-relaxed max-w-md text-sm md:text-base">
              搭讪吃瓜是专注搭讪话术、开场白套路与金句技巧的内容社区。我们不贩卖焦虑，
              只陪你一起看懂现场、避开雷区、聊出温度。
            </p>

            <div className="mt-6 max-w-md">
              <p className="text-sm font-medium text-background-50">
                订阅「开饭提醒」，不错过每一轮新瓜
              </p>
              <form
                data-readdy-form="搭讪吃瓜邮件订阅表单"
                onSubmit={onSubmit}
                className="mt-3 flex flex-col sm:flex-row gap-2"
                noValidate
              >
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="请输入常用邮箱"
                  aria-label="常用邮箱"
                  className="flex-1 h-11 rounded-full bg-background-50 text-foreground-900 px-4 text-sm outline-none placeholder:text-foreground-400"
                />
                <input
                  type="text"
                  name="website_alt"
                  aria-hidden="true"
                  tabIndex={-1}
                  autoComplete="off"
                  readOnly
                  className="honeypot-field"
                />
                <button
                  type="submit"
                  className="h-11 px-5 rounded-full bg-accent-500 text-foreground-950 font-medium hover:bg-accent-400 whitespace-nowrap transition-colors cursor-pointer text-sm"
                >
                  订阅
                  <i className="ri-send-plane-fill ml-1.5"></i>
                </button>
              </form>
              {status === "ok" && (
                <p className="mt-2 text-sm text-accent-200 flex items-center gap-1.5">
                  <i className="ri-checkbox-circle-fill"></i> {msg}
                </p>
              )}
              {status === "err" && (
                <p className="mt-2 text-sm text-background-100 flex items-center gap-1.5">
                  <i className="ri-error-warning-fill"></i> {msg}
                </p>
              )}
            </div>
          </div>

          {/* 栏目 */}
          <div className="lg:col-span-3">
            <h4 className="text-sm font-medium text-background-50/90 uppercase tracking-wide">
              内容栏目
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navItems.map((n) => (
                <li key={n.href}>
                  <a
                    href={n.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(n.href);
                    }}
                    className="text-background-100/90 hover:text-background-50 inline-flex items-center gap-1.5 cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-accent-200"></i>
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 关于 + 联系 */}
          <div className="lg:col-span-4">
            <h4 className="text-sm font-medium text-background-50/90 uppercase tracking-wide">
              联系我们
            </h4>
            <ul className="mt-4 flex flex-col gap-3 text-background-100/90">
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line text-accent-200 mt-0.5"></i>
                <a href="mailto:hello@dashan-chigua.example.com" className="hover:text-background-50">
                  hello@dashan-chigua.example.com
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-message-3-line text-accent-200 mt-0.5"></i>
                <span>投稿你的搭讪故事 / 聊天记录，欢迎来吃瓜或开瓜</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line text-accent-200 mt-0.5"></i>
                <span>编辑部每周一、三、五更新热瓜</span>
              </li>
            </ul>
            <div className="mt-5 flex gap-2.5">
              {[
                { icon: "ri-wechat-fill", label: "微信" },
                { icon: "ri-weibo-fill", label: "微博" },
                { icon: "ri-douban-fill", label: "豆瓣" },
                { icon: "ri-rss-fill", label: "RSS" },
              ].map((s) => (
                <button
                  key={s.label}
                  aria-label={s.label}
                  className="w-10 h-10 rounded-full bg-background-50/10 hover:bg-background-50/20 flex items-center justify-center cursor-pointer transition-colors"
                >
                  <i className={`${s.icon} text-lg text-background-50`}></i>
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-100/70">
          <p>© {new Date().getFullYear()} 搭讪吃瓜 · 把心动说出口。保留所有权利。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-fill text-primary-200"></i>
            边吃瓜，边学点用得上的社交话术
          </p>
        </div>
      </div>
    </footer>
  );
}